var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_2174)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9769 23.9136V13.2512C19.9613 15.0323 23.0472 16.7529 26.6969 18.6079C23.6867 20.1939 19.9613 21.9734 15.9769 23.9136ZM38.182 7.94825C37.4947 7.08801 36.3233 6.41838 35.0762 6.19669C31.4105 5.53539 8.54197 5.53351 4.8783 6.19669C3.87822 6.3748 2.98767 6.8053 2.22267 7.47418C-1.00073 10.3164 0.00933242 25.5583 0.786294 28.0272C1.11301 29.0959 1.53538 29.8666 2.0673 30.3725C2.75262 31.0414 3.69093 31.5019 4.76872 31.7085C7.78691 32.3015 23.3361 32.6331 35.0124 31.7975C36.0882 31.6194 37.0405 31.144 37.7915 30.4467C40.7719 27.6159 40.5687 11.5181 38.182 7.94825Z",
    fill: "#F1E1C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_2174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.776f31db5ada81e443def5cb701e0b99.svg";
export { ForwardRef as ReactComponent };